import type { IconType } from 'react-icons';
import { TbAlertTriangle, TbCircle, TbStar } from 'react-icons/tb';

export const weightLabelByValue: Record<number, string> = {
  1: 'Standard',
  2: 'Important',
  3: 'Critical',
};

export const weightBadgeClassByValue: Record<number, string> = {
  1: 'bg-success-50 border-success-200 text-success-700',
  2: 'bg-primary-50 border-warning-200 text-warning-700',
  3: 'bg-warning-50 border-danger-200 text-danger-700',
};

export const weightIconByValue: Record<number, IconType> = {
  1: TbCircle,
  2: TbStar,
  3: TbAlertTriangle,
};

export const normalizeMarkWeight = (weight?: number | null): number => weight ?? 1;

export const isKeyMarkWeight = (weight?: number | null): boolean => normalizeMarkWeight(weight) >= 2;

export const getWeightLabel = (weight?: number | null): string =>
  weightLabelByValue[normalizeMarkWeight(weight)] ?? weightLabelByValue[1];

export const getWeightBadgeClass = (weight?: number | null): string =>
  weightBadgeClassByValue[normalizeMarkWeight(weight)] ?? weightBadgeClassByValue[1];

export const getWeightIcon = (weight?: number | null): IconType =>
  weightIconByValue[normalizeMarkWeight(weight)] ?? weightIconByValue[1];
